<app-header></app-header>
<app-stepper [steps$]="applicationStateService.steps$"></app-stepper>

<div class="content" appScrollShadow>
  <h1 class="title">For how long are you visiting us?</h1>
  <h2 class="title">Please select the date or duration of your visit:</h2>

  <daui-date-panel class="wrapper" [datePreset]="[]" [fixStartDate]="fixStartDate" [selectedDate]="fixStartDate"
    [maxDate]="maxDate" [intervalSelection]="true" [endDate]="trainingEndDateString" [size]="1"
    (selectedIntervalDateChange)="onSelectDate($event)"></daui-date-panel>
</div>

<app-footer-actions>
  <button left class="previous-page" (click)="back()" [disabled]="isRunningProcess">
    <i class="icon icon-arrow-left"></i>
    <span class="label">Back</span>
  </button>
  <button right class="next-page" (click)="next()" [disabled]="isRunningProcess">
    <span class="label">Next</span>
    <i class="icon icon-arrow-right"></i>
  </button>
</app-footer-actions>